"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatFeed = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
let ChatFeed = class ChatFeed extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <slot></slot>
    `;
    }
};
ChatFeed.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--space-section);
      flex: none;
      width: 100%;
      max-width: var(--layout-width-small);
      margin: var(--space-8) auto 0;
      box-sizing: border-box;
    }
  `;
ChatFeed = __decorate([
    (0, decorators_js_1.customElement)('mm-chat-feed')
], ChatFeed);
exports.ChatFeed = ChatFeed;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhdC1mZWVkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY2hhdC1mZWVkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBaUQ7QUFHMUMsSUFBTSxRQUFRLEdBQWQsTUFBTSxRQUFTLFNBQVEsZ0JBQVU7SUFjdEMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7O0tBRVYsQ0FBQTtJQUNILENBQUM7O0FBakJNLGVBQU0sR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7Ozs7Ozs7R0FXbEIsQ0FBQTtBQVpVLFFBQVE7SUFEcEIsSUFBQSw2QkFBYSxFQUFDLGNBQWMsQ0FBQztHQUNqQixRQUFRLENBbUJwQjtBQW5CWSw0QkFBUSJ9